import ApiRequests from "../apiRequests";

class PropertyService extends ApiRequests {
  constructor() {
    super("properties");
  }
}

export default PropertyService;
